import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisShareViewRoute: InvariantJiraRoute = {
	name: 'polaris-share-view',
	path: '/jira/discovery/share/:section/:resource',
	query: ['selectedIssue?', 'issueViewLayout?'],
	exact: true,
};
